const PLACEHOLDERS = [
    {
        number: '1 - lodaing data...',
        trains:[
            {
                route: '',
                destination: '',
                times: []
            }
        ]
    }
];

const TRANSPORT_TYPES = {
    BUSS: 'buss',
    PLANE: 'plane',
    TRAIN: 'train',
    METRO: 'metro'
};

export {
    PLACEHOLDERS,
    TRANSPORT_TYPES
};